import $ from 'jquery';
import _ from 'underscore';
import {
  REQUEST_PROFILE_FOLLOWING,
  RECEIVE_PROFILE_FOLLOWING,
  FAIL_PROFILE_FOLLOWING_REQUEST,
  REQUEST_FOLLOW_FEED_USER,
  RECEIVE_FEED_USER_FOLLOWED,
  FAIL_FEED_USER_FOLLOW_REQUEST,
  REQUEST_UNFOLLOW_FEED_USER,
  RECEIVE_FEED_USER_UNFOLLOWED,
  FAIL_FEED_USER_UNFOLLOW_REQUEST,
} from 'common/actions';

const defaultState = {
  // True if equest has been sent, no response yet
  requesting: false,

  // Last request was successful but returned no results,
  // or last request failed
  allComplete: false,

  // Error object if request not in 200 range
  error: null,

  // Oldest friend datetime (allows for pagination)
  oldestDateTime: null,

  // The friend objects
  users: [],
};

function following(state = defaultState, action) {
  const newState = $.extend(true, {}, defaultState, state);
  switch (action.type) {
  // Actions around populating the following list
  case REQUEST_PROFILE_FOLLOWING:
    newState.requesting = true;
    newState.allComplete = false;
    break;
  case RECEIVE_PROFILE_FOLLOWING:
    const json = action.payload.json;

    // We are no longer requesting
    newState.requesting = false;

    if (Array.isArray(json)) {
      // Parse dates
      const newUsers = json.map(item => {
        item.dateFollowed = new Date(item.dateFollowed);
        return item;
      });

      // Add new users to existing
      newState.users = _.uniq(newState.users.concat(newUsers), item => item.userId);
      newState.users = _.sortBy(newState.users, item => -item.dateFollowed.getTime());

      // If no new users, mark complete
      if (json.length === 0) {
        newState.allComplete = true;
      }

      // Set oldest datetime
      newState.oldestDateTime = new Date();
      const timestamps = _.map(newState.users, item => item.dateFollowed.getTime());
      const minTime = _.min(timestamps);
      newState.oldestDateTime.setTime(minTime);
    }
    break;
  case FAIL_PROFILE_FOLLOWING_REQUEST:
    newState.requesting = false;
    newState.allComplete = true;
    newState.error = action.payload;
    break;

  // Actions around following friends of the profile
  case REQUEST_FOLLOW_FEED_USER:
  case REQUEST_UNFOLLOW_FEED_USER:
    if (!action.payload.isCurrentProfile) {
      const affectedFriend = newState.users
        .find(friend => friend.userId === action.payload.feedUserRelatedId);
      if (affectedFriend) {
        affectedFriend.followRequestPending = true;
      }
    }
    break;
  case RECEIVE_FEED_USER_FOLLOWED:
    if (!action.payload.isCurrentProfile) {
      let affectedFriend = newState.users
        .find(friend => friend.userId === action.payload.feedUserRelatedId);
      if (!affectedFriend && action.payload.userIsOnOwnProfile) {
        if (action.payload.followerInfo) {
          newState.users.unshift(action.payload.followerInfo);
          affectedFriend = action.payload.followerInfo;
        }
      }
      if (affectedFriend) {
        affectedFriend.followRequestPending = false;
        affectedFriend.currentUserIsFollowing = true;
        affectedFriend.followerCount += 1;
        affectedFriend.dateFollowed = new Date();
      }
    }
    break;
  case RECEIVE_FEED_USER_UNFOLLOWED:
    if (!action.payload.isCurrentProfile) {
      const indexOfFriend = _.findIndex(newState.users,
        u => u.userId === action.payload.feedUserRelatedId && u.feedUserType === action.payload.feedUserTypeId);
      if (indexOfFriend !== -1) {
        newState.users.splice(indexOfFriend, 1);
      }
    }
    break;
  case FAIL_FEED_USER_FOLLOW_REQUEST:
  case FAIL_FEED_USER_UNFOLLOW_REQUEST:
    if (!action.payload.isCurrentProfile) {
      const affectedFriend = newState.users
        .find(friend => friend.userId === action.payload.feedUserRelatedId);
      if (affectedFriend) {
        affectedFriend.followRequestPending = false;
        affectedFriend.followRequestError = action.payload;
      }
    }
    break;
  default:
    return state;
  }
  return newState;
}

export default following;
